module.exports = __webpack_public_path__ + "static/img/game-type-yyhyddp.1dc2f42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-type-yyhyddp.png
// module id = s8Ee
// module chunks = 1